import { render, staticRenderFns } from "./projectList.vue?vue&type=template&id=453c7988&scoped=true"
import script from "./projectList.vue?vue&type=script&lang=js"
export * from "./projectList.vue?vue&type=script&lang=js"
import style0 from "./projectList.vue?vue&type=style&index=0&id=453c7988&prod&lang=scss&scoped=true"
import style1 from "./projectList.vue?vue&type=style&index=1&id=453c7988&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c7988",
  null
  
)

export default component.exports